<template>
  <div class="animated fadeIn">
    <b-modal ref="authmodal" hide-footer title="REPROVAR AUTORIZAÇÃO DE DESPESAS">
      <div class="d-block text-left">
        <h5>Informe o motivo da reprovação</h5>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.descricao.value"
                      :placeholder="'Descreva aqui o motivo da reprovação da autorização de despesas'"
                      :rows="form.descricao.rows"
                      :size="form.descricao.maxlength"
                      :noResize="form.descricao.noResize"></b-form-textarea>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-3 pb-2 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSetDisapproved" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span></button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
const formModal = {
  descricao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}

export default {
  name: 'AuthorizationsModal',
  data () {
    return {
      data: null,
      form: formModal
    }
  },
  methods: {
    showModal () {
      this.$refs['authmodal'].show()
    },
    hideModal () {
      this.$refs['authmodal'].hide()
    },
    onSetDisapproved () {
      if (this.form.descricao.value) {
        this.$emit('SetDisapproved', this.form.descricao.value)
        this.hideModal()
      } else {
        toast.info('Você precisa informar o motivo da reprovação da autorização para despesas', 'REPROVAR AUTORIZAÇÃO')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/authorizations/authorizations-modal.vue